import styled from "@emotion/styled";
import { Paper } from "@mui/material";

export const UserSettingsSkeletonSectionContainer = styled(Paper)(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	padding: "16px",
	"& > div:first-of-type": {
		...theme.project.typography.subtitle.subtitle1
	}
}));
